
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";
import { ManufacturerSearchCriteria } from "../../models/api/system/manufacturers";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ManufacturerSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  localManufacturers: any = [];

  @Prop({ default: () => null })
  public manufacturers: any[] = null;

  @Prop({ default: null })
  public billTo: string;

  @Prop({ default: false })
  public preload: true;

  async created() {
    if (this.preload) {
      let criteria: ManufacturerSearchCriteria = { name: "", billTo: this.billTo };
      let results = await systemModule.searchManufacturersByName(criteria);
      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
    }
  }

  async search(value, loading) {
    if (this.manufacturers || this.preload) return;

    loading(true);
    try {
      let criteria: ManufacturerSearchCriteria = { name: value, billTo: this.billTo };

      let results = await systemModule.searchManufacturersByName(criteria);

      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
    } finally {
      loading(false);
    }
  }

  get items() {
    if (this.manufacturers) return this.manufacturers;
    return this.localManufacturers;
  }

  @Watch("billTo")
  async function(newVal, oldVal) {
    if (this.preload) {
      let criteria: ManufacturerSearchCriteria = { name: "", billTo: this.billTo };
      let results = await systemModule.searchManufacturersByName(criteria);
      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
    }
  }
}
